module.exports = __webpack_public_path__ + "img/product-3-work.4dfd599a.png";